export enum EnumEstadoFactura {
  Borrador = 1,
  Emitida = 2,
  Validada = 3,
  Conciliada = 4,
  Pagada = 5,
  Generada = 6,
  Incompleta = 7,
  Rechazada = 20,
  Finalizada = 21,
  Impago = 22,
  Descartada = 23,
  Anulada = 24
}
